import React, { useState, useRef, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import VisibilitySensor from 'react-visibility-sensor';
import { Tag } from '@ontruck/orc';
import { injectIntl } from 'react-intl';

const ReasonsCell = ({ className, id, reasons, intl }) => {
  const labels = intl.messages.modules.job_review.reasons;
  const t_reasons = {
    no_vehicle_assigned_to_journey: labels.no_vehicle_assigned_to_journey,
    unsuitable_vehicle_type_for_journey: labels.unsuitable_vehicle_type_for_journey,
    problematic_day_for_driver: labels.problematic_day_for_driver,
  };
  const [reasonsVisibility, setReasonsVisibility] = useState({});
  const reasonsRef = useRef(null);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const hiddenReasons = Object.keys(reasonsVisibility)
    .filter((reason) => !reasonsVisibility[reason])
    .map((reason) => reason);

  const lastVisibleIndex =
    Object.keys(reasonsVisibility).filter((reason) => reasonsVisibility[reason]).length - 1;

  const hiddenReasonsComponent = (
    <Tag
      text={`+${hiddenReasons.length}`}
      skin="modernLightGrey"
      data-tip={hiddenReasons.map((reason) => t_reasons[reason]).join('<br />')}
      data-for="reasons-tooltip"
      weight="bold"
      data-multiline={true}
    />
  );

  const notVisibleReasons = hiddenReasons?.length === reasons?.length && !!reasons?.length;

  return (
    <div ref={reasonsRef} className={className}>
      {notVisibleReasons && hiddenReasonsComponent}
      {reasons?.map((reason, key) => (
        <VisibilitySensor
          key={reason}
          containment={reasonsRef.current}
          onChange={(visible) =>
            setReasonsVisibility((status) => ({
              ...status,
              [reason]: visible,
            }))
          }
          offset={{ right: 36 }}
        >
          {({ isVisible }) => (
            <>
              <Tag
                text={t_reasons[reason]}
                skin="modernLightGrey"
                weight="bold"
                textTransform="uppercase"
                className="reason"
                style={!isVisible ? { visibility: 'hidden' } : {}}
              />
              {key === lastVisibleIndex && !!hiddenReasons.length && hiddenReasonsComponent}
            </>
          )}
        </VisibilitySensor>
      ))}
    </div>
  );
};

export default injectIntl(ReasonsCell);
